import { Box, Stack } from "@mui/material"
import { useLocalization } from "@tm/localization"
import { ErpPrice } from "@tm/models"
import { TooltipPriceTypography } from "./TooltipPriceTypography"

type Props = {
    price: ErpPrice
    showTaxIncluded: boolean
    isStrikeThrough?: boolean
}

export function TooltipPrice(props: Props) {
    const { price, showTaxIncluded, isStrikeThrough } = props
    const { formatCurrency, translateText, formatNumber } = useLocalization()

    const hasSecondaryPrice = price?.secondaryValue !== undefined

    const formattedPrice = getFormattedPriceString(price?.value, price?.currencyCode_Iso_4217, price?.currencySymbol, hasSecondaryPrice)
    const formattedPriceTaxIncluded = getFormattedPriceString(
        price?.valueTaxIncluded,
        price?.currencyCode_Iso_4217,
        price?.currencySymbol,
        hasSecondaryPrice
    )

    const formattedSecondaryPrice = getFormattedPriceString(
        price?.secondaryValue,
        price?.secondaryCurrencyCode_Iso_4217,
        price?.secondaryCurrencySymbol,
        hasSecondaryPrice
    )
    const formattedSecondaryPriceTaxIncluded = getFormattedPriceString(
        price?.secondaryValueTaxIncluded,
        price?.secondaryCurrencyCode_Iso_4217,
        price?.secondaryCurrencySymbol,
        hasSecondaryPrice
    )

    function getFormattedPriceString(
        value: number | undefined,
        currencyCode: string | undefined,
        currencySymbol: string | undefined,
        useCurrencyCodeForFormatting: boolean
    ): string | undefined {
        if (value) {
            if (useCurrencyCodeForFormatting) {
                return formatCurrency(value, currencyCode || currencySymbol || "")
            }
            return formatCurrency(value, currencySymbol || currencyCode || "")
        }
        return undefined
    }

    return (
        <Stack spacing={0.5}>
            {!!price.description && (
                <Box display="flex" gap={1} justifyContent="space-between">
                    <TooltipPriceTypography isStrikeThrough={isStrikeThrough}>{`${price.description}:`}</TooltipPriceTypography>
                    <TooltipPriceTypography isStrikeThrough={isStrikeThrough}>{formattedPrice}</TooltipPriceTypography>
                </Box>
            )}
            {!!price.description && !!formattedSecondaryPrice && (
                <Box display="flex" gap={1} justifyContent="end">
                    <TooltipPriceTypography isStrikeThrough={isStrikeThrough}>{formattedSecondaryPrice}</TooltipPriceTypography>
                </Box>
            )}

            {!price.taxIncluded && showTaxIncluded && formattedPriceTaxIncluded && (
                <Box display="flex" gap={1} justifyContent="space-between">
                    <TooltipPriceTypography>{translateText(12851)}:&nbsp;</TooltipPriceTypography>
                    <TooltipPriceTypography>{formattedPriceTaxIncluded}</TooltipPriceTypography>
                </Box>
            )}

            {!price.taxIncluded && showTaxIncluded && formattedSecondaryPriceTaxIncluded && (
                <Box display="flex" justifyContent="end" gap={1}>
                    <TooltipPriceTypography>{formattedSecondaryPriceTaxIncluded}</TooltipPriceTypography>
                </Box>
            )}

            {!!price.rebatePercent && (
                <Box>
                    {translateText(54)}:&nbsp;
                    {formatNumber(price.rebatePercent, 0, 2)}%
                </Box>
            )}
        </Stack>
    )
}
